<template>
  <path
    d="M18.4 10.6002C16.55 8.99018 14.15 8.00018 11.5 8.00018C7.34004 8.00018 3.76004 10.4202 2.06004 13.9302C1.74004 14.6002 2.10004 15.4002 2.81004 15.6402C3.40004 15.8402 4.04004 15.5602 4.31004 15.0002C5.61004 12.3402 8.34004 10.5002 11.5 10.5002C13.45 10.5002 15.23 11.2202 16.62 12.3802L14.71 14.2902C14.08 14.9202 14.52 16.0002 15.41 16.0002H21C21.55 16.0002 22 15.5502 22 15.0002V9.41018C22 8.52018 20.92 8.07018 20.29 8.70018L18.4 10.6002Z"
  />
</template>
